module.exports = __webpack_public_path__ + "img/nodejs.4c6c0929.png";